export const VisitorScoringHandler = {
  setup() {},
};
